/**
 * Common Colors
 * Base colors used throughout the application
 */

import { palette, createColor } from './palette.colors';

export const commonColors = {
  // Basic colors
  white: createColor(palette.gray.white, palette.gray.white),
  black: createColor(palette.gray.field, palette.dark.content),
  transparent: createColor(palette.special.transparent),
  
  // Grays
  lightWhite: createColor(palette.blue.appBG, palette.blue.onTint),
  lightBlack: createColor(palette.gray.offBlack),
  lightGrey: createColor(palette.gray.medium),
  darkGrey: createColor(palette.gray.userInitial),
  shadedGrey: createColor(palette.gray.shade),
  iconGrey: createColor(palette.gray.icon),
  title: createColor(palette.blue.onTint, palette.gray.white),
  
  // Semantic colors
  red: createColor(palette.semantic.red),
  green: createColor(palette.semantic.green),
  
  // Background & Text
  textLight: createColor(palette.gray.ultraLight),
  cardBackground: createColor(palette.gray.card),
  backgroundDark: createColor(palette.gray.deep),
  subTextDark: createColor(palette.gray.text),
  subInterText: createColor(palette.gray.subText),
  viewBorder: createColor(palette.gray.border),
  iconWhite: createColor(palette.gray.border),
  iconBlue: createColor(palette.blue.icon),
  headerBG: createColor(palette.gray.white, palette.blue.onTint),
  BG: createColor(palette.gray.white, palette.blue.onTint),
  darkRed: createColor(palette.semantic.dangerRed, palette.semantic.mandoratoryRed),
  shiftStatus: createColor(palette.borders.selected,  palette.gray.lightDarkGrey),
  sortIcon: createColor(palette.blue.onTint,  palette.gray.white),
  sortSelectedIcon: createColor(palette.blue.selectedText,  palette.blue.selectedBorder),
  border: createColor('transparent', palette.gray.lightDarkGrey),
};